import axios from "axios";
import dotenv from "dotenv";
dotenv.config();

let apiUrl;
if (process.env.NODE_ENV === "production") {
  apiUrl = `${process.env.REACT_APP_SITE_URL}`;
} else {
  apiUrl = `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_PORT}`;
}
export const manualUploadAPI = {
  importFile: async (fileContent, fileName, type) => {
    //axios.post(`${config.baseUrl}${config.importFile}${config.importFileCode}`, fileContent, {
    try {
      const res = await axios.post(
        `${apiUrl}${process.env.REACT_APP_UPLOAD_BLACKLIST_ENDPOINT}${process.env.REACT_APP_UPLOAD_BLACKLIST_CODE}`,
        fileContent,
        {
          headers: {
            "Content-Type": "text/plain",
          },
          params: {
            fileName: fileName,
            type: type,
          },
          timeout: 60000,
        }
      );

      return res;
    } catch (error) {
      if (error?.response?.status === 401) {
        window.sessionStorage.removeItem("user");
        window.sessionStorage.clear();
        window.location.href = "/Unauthorized";
      }
      if (error?.response?.data) {
        return error.response.data;
      }
      console.log(error);
      throw error;
    }
  },
};
